import { render } from "./AddPublication.vue?vue&type=template&id=3caf2f24&scoped=true&ts=true"
import script from "./AddPublication.vue?vue&type=script&lang=ts"
export * from "./AddPublication.vue?vue&type=script&lang=ts"

import "./AddPublication.vue?vue&type=style&index=0&id=3caf2f24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caf2f24"]])

export default __exports__